import { render } from "./EditorHtml.vue?vue&type=template&id=5af7c85a&ts=true"
import script from "./EditorHtml.vue?vue&type=script&lang=ts"
export * from "./EditorHtml.vue?vue&type=script&lang=ts"

import "./EditorHtml.vue?vue&type=style&index=0&id=5af7c85a&lang=css"

import exportComponent from "D:\\UniRH\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__